import {EntityType, Team} from "./Model";
import {arrayResource, EntityStore, startEntityStore} from "./resourceStoreBuilder";
import {create} from "zustand";
import {Teams_Read} from "../util/access/Permission";

export const useTeamStore = create<EntityStore<Team[]>>()(
    arrayResource<Team, EntityStore<Team[]>>(EntityType.Teams, builder => {
        const rest = builder.rest('/teams');

        return {
            remoteValue: builder.all(Teams_Read, () => rest.getAll()),
        };
    })
);

startEntityStore(useTeamStore);
